export default "__VITE_ASSET__BUimR17z__"